import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useState, useCallback, useEffect } from 'react';

var useOverflowNav = function useOverflowNav(props) {
  var containerRef = props.containerRef;

  var _useState = useState([]),
      overflowItems = _useState[0],
      setOverflowItems = _useState[1];

  var handleIntersection = useCallback(function (entries) {
    entries.forEach(function (entry) {
      var itemId = entry.target.dataset.itemId;
      if (!itemId) return;

      if (!entry.isIntersecting) {
        setOverflowItems(function (prevState) {
          var _a;

          if (prevState.includes(itemId)) return prevState;
          var allItems = Array.from(((_a = containerRef.current) == null ? void 0 : _a.children) || []);
          var allItemIds = allItems.map(function (item) {
            return item.dataset.itemId;
          }).filter(Boolean);
          var newItems = [].concat(_toConsumableArray(prevState), [itemId]);
          return newItems.sort(function (a, b) {
            return allItemIds.indexOf(a) - allItemIds.indexOf(b);
          });
        });
      } else {
        setOverflowItems(function (prevState) {
          return prevState.filter(function (item) {
            return item !== itemId;
          });
        });
      }
    });
  }, [containerRef]);
  useEffect(function () {
    var root = containerRef.current;
    var hasBrowserSupport = !!window.IntersectionObserver;
    if (!hasBrowserSupport || !root) return;
    var observer = new IntersectionObserver(handleIntersection, {
      threshold: 1,
      root: root,
      rootMargin: "0px -48px 0px 0px"
    });
    Array.from(containerRef.current.children).forEach(function (item) {
      observer.observe(item);
    });
    return function () {
      return observer.disconnect();
    };
  }, [containerRef, handleIntersection]);
  return overflowItems;
};

export { useOverflowNav };